import type { RunnerId } from '@ps/isp-web-services-types';

export const generateRunnerKey = ({ marketId, selectionId }: RunnerId) =>
  `${marketId}_${selectionId}`;
